// Mirrors the server's /api/auth/me fields. Only for showing menus and pages;
// the API enforces every permission again on each request.
export const STAFF_ONLY_ROLE = 'pool_manager';
export const permissionList = user => (Array.isArray(user?.permissions) ? user.permissions : []);
export const hasPermission = (user, permission) => permissionList(user).includes(permission);
export const isMainAdmin = user => user?.role === 'admin';
export const isStaffOnly = user => user?.role === STAFF_ONLY_ROLE;
export const isStaffUser = user => !isMainAdmin(user) && hasPermission(user, 'pool.view');
export const staffRoleLabel = role => (role === 'pool_manager' ? 'Havuz Yöneticisi' : 'Yok');

// Staff work pages, added as each phase ships them ({ path, label, icon, permission }).
// Only pages that really exist are listed; menus and the staff home read this list.
export const STAFF_SECTIONS = [
  { path: '/admin/pool', label: 'Havuz Yönetimi', permission: 'pool.view', icon: 'pool' },
  { path: '/admin/reviews', label: 'Onay Bekleyenler', permission: 'review.dna', icon: 'reviews' },
  { path: '/admin/reports', label: 'Şikâyetler', permission: 'reports.review', icon: 'reports' },
  { path: '/admin/event-reviews', label: 'Etkinlik doğrulamaları', permission: 'events.verify', icon: 'events' },
];
export const staffSections = user => STAFF_SECTIONS.filter(section => hasPermission(user, section.permission));

const AUDIT_LABELS = {
  'staff.assign': 'Personel rolü verildi',
  'staff.revoke': 'Personel yetkisi kaldırıldı',
  'staff.invite.create': 'Personel daveti oluşturuldu',
  'staff.invite.revoke': 'Personel daveti iptal edildi',
  'staff.invite.redeem': 'Personel daveti ile hesap açıldı',
  'dna.review.approve': 'Profil onaylandı',
  'dna.review.request_changes': 'Profil için düzeltme istendi',
  'dna.review.reject': 'Profil reddedildi',
  'dna.review.revoke': 'Profil yayından kaldırıldı',
  'external_profile.create': 'Dış kart oluşturuldu',
  'external_profile.update': 'Dış kart düzenlendi',
  'external_profile.publish': 'Dış kart doğrulandı ve yayınlandı',
  'external_profile.suppress': 'Dış kart yayından kaldırıldı',
  'external_profile.republish': 'Dış kart tekrar yayınlandı',
  'external_profile.hard_delete': 'Dış kart kalıcı silindi',
  'external_import.create': 'Dosyadan dış kart içe aktarıldı',
  'external_import.rollback': 'İçe aktarma geri alındı',
  'claim_invite.create': 'Üyelik daveti oluşturuldu',
  'claim_invite.revoke': 'Üyelik daveti iptal edildi',
  'claim_invite.redeem': 'Davet kullanıldı, kart sahiplenildi',
  'claim_invite.complete': 'Kart üyelik profiline dönüştü',
  'venue_invite.create': 'Mekân daveti oluşturuldu',
  'venue_invite.revoke': 'Mekân daveti iptal edildi',
  'report.review': 'Şikâyet incelemeye alındı',
  'report.resolved': 'Şikâyet sonuçlandırıldı',
  'report.dismissed': 'Şikâyet reddedildi',
  'sanction.apply': 'İletişim askısı uygulandı',
  'sanction.lift': 'İletişim askısı kaldırıldı',
  'event_review.queued': 'Etkinlik kaydı 7 gün yanıtsızlıkla incelemeye alındı',
  'event_review.verified': 'Etkinlik ekip incelemesiyle doğrulandı',
  'event_review.rejected': 'Etkinlik ekip incelemesinde doğrulanmadı',
};
export const auditActionLabel = action => AUDIT_LABELS[action] || action;
export const formatDateTime = value => value && !Number.isNaN(new Date(value).getTime())
  ? new Date(value).toLocaleString('tr-TR', { timeZone: 'Europe/Istanbul' }) : '—';
